import { render } from "./EducationalView.vue?vue&type=template&id=6eae9e94&scoped=true"
import script from "./EducationalView.vue?vue&type=script&lang=js"
export * from "./EducationalView.vue?vue&type=script&lang=js"

import "./EducationalView.vue?vue&type=style&index=0&id=6eae9e94&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eae9e94"]])

export default __exports__